// The public website (landing page, privacy policy, public lessons) lives next to the app: app.webots.academy
// pairs with webots.academy and app.dev.webots.academy with dev.webots.academy. Elsewhere (localhost) it comes
// from REACT_APP_SITE_URL.
const DEFAULT_SITE_URL = 'https://webots.academy';

function siteOrigin(): string {
  if (typeof window !== 'undefined' && window.location.hostname.startsWith('app.')) {
    return `${window.location.protocol}//${window.location.hostname.slice('app.'.length)}`;
  }
  return (process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL).replace(/\/$/, '');
}

export function siteUrl(path = '/'): string {
  return `${siteOrigin()}${path.startsWith('/') ? path : `/${path}`}`;
}
